import React, { Fragment, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GreenLogo from "../layout/Innovators/GreenLogo";
import RedLogo from "../layout/Mentors/RedLogo";
import BlueLogo from "../layout/Employers/BlueLogo";

const SetupProfileUsers = ({ auth: { user, isAuthenticated } }) => {
  const [view, setView] = useState({
    innovators: true,
    mentors: false,
    employers: false,
    companies: false,
  });
  const [viewAlt, setViewAlt] = useState({
    mentors: true,
    employers: false,
    companies: false,
  });
  const [viewAltTwo, setViewAltTwo] = useState({
    employers: true,
    mentors: false,
    companies: false,
  });

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {user.role === "innovator" && (
        <div className="setup-users-container">
          <div className="initialize-title">
            <div className="flex-alt">
              <div className="logo-setup">
                <GreenLogo />
              </div>
              <h1 className="setup-heading green">Network with ime Users</h1>
            </div>
            <p className="lead">
              Connect with users similar to{" "}
              <span className="green bold largest-font mx-5">
                "{user.jobtitle}"
              </span>{" "}
              on ime
            </p>
          </div>
          <div className="setup-users-container">
            <div className="section-info">
              <p className="setup-info">See users below:</p>
              <Link to={`/${user.channelid}`}>
                <p className="setup-next white">
                  Finish{" "}
                  <i className="fas fa-arrow-circle-right green mx-5"></i>
                </p>
              </Link>
            </div>
            <div className="active-view-alt">
              <button
                onClick={() =>
                  setView({
                    innovators: true,
                    mentors: false,
                    employers: false,
                    companies: false,
                  })
                }
                className={
                  view.innovators
                    ? "section-title green background-black-lighten underline"
                    : "section-title green background-black-lighten"
                }
              >
                Innovators
              </button>
              <button
                onClick={() =>
                  setView({
                    innovators: false,
                    mentors: true,
                    employers: false,
                    companies: false,
                  })
                }
                className={
                  view.mentors
                    ? "section-title red background-black-lighten underline"
                    : "section-title red background-black-lighten"
                }
              >
                Mentors
              </button>
              <button
                onClick={() =>
                  setView({
                    innovators: false,
                    mentors: false,
                    employers: true,
                    companies: false,
                  })
                }
                className={
                  view.employers
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Employers
              </button>
              <button
                onClick={() =>
                  setView({
                    innovators: false,
                    mentors: false,
                    employers: false,
                    companies: true,
                  })
                }
                className={
                  view.companies
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Companies
              </button>
            </div>
            <div className="setup-users-container-alt">
              {view.innovators && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 green"></i>
                    <p className="section-name">Innovators</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border green">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="green name-font">
                                  User Name
                                </span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-green">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {view.mentors && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 red"></i>
                    <p className="section-name">Mentors</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {view.employers && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Employers</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {view.companies && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Companies</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      )}
      {user.role === "mentor" && (
        <div className="setup-users-container">
          <div className="initialize-title">
            <div className="flex-alt">
              <div className="logo-setup">
                <RedLogo />
              </div>
              <h1 className="setup-heading red">Network with ime Users</h1>
            </div>
            <p className="lead">
              Connect with users similar to{" "}
              <span className="red bold largest-font mx-5">
                "{user.jobtitle}"
              </span>{" "}
              on ime
            </p>
          </div>
          <div className="setup-users-container">
            <div className="section-info">
              <p className="setup-info">See users below:</p>
              <Link to={`/${user.channelid}/setupmentors`}>
                <p className="setup-next white">
                  Finish <i className="fas fa-arrow-circle-right red mx-5"></i>
                </p>
              </Link>
            </div>
            <div className="active-view-alt">
              <button
                onClick={() =>
                  setViewAlt({
                    mentors: true,
                    employers: false,
                    companies: false,
                  })
                }
                className={
                  viewAlt.mentors
                    ? "section-title red background-black-lighten underline"
                    : "section-title red background-black-lighten"
                }
              >
                Mentors
              </button>
              <button
                onClick={() =>
                  setViewAlt({
                    mentors: false,
                    employers: true,
                    companies: false,
                  })
                }
                className={
                  viewAlt.employers
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Employers
              </button>
              <button
                onClick={() =>
                  setViewAlt({
                    mentors: false,
                    employers: false,
                    companies: true,
                  })
                }
                className={
                  viewAlt.companies
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Companies
              </button>
            </div>
            <div className="setup-users-container-alt">
              {viewAlt.mentors && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 red"></i>
                    <p className="section-name">Mentors</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {viewAlt.employers && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Employers</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {viewAlt.companies && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Companies</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      )}
      {user.role === "employer" && (
        <div className="setup-users-container">
          <div className="initialize-title">
            <div className="flex-alt">
              <div className="logo-setup">
                <BlueLogo />
              </div>
              <h1 className="setup-heading blue">Network with ime Users</h1>
            </div>
            <p className="lead">
              Connect with users similar to{" "}
              <span className="blue bold largest-font mx-5">
                "{user.companyname}"
              </span>{" "}
              on ime
            </p>
          </div>
          <div className="setup-users-container">
            <div className="section-info">
              <p className="setup-info">See users below:</p>
              <Link to={`/setupemployers/${user.channelid}`}>
                <p className="setup-next white">
                  Next <i className="fas fa-arrow-circle-right blue mx-5"></i>
                </p>
              </Link>
            </div>
            <div className="active-view-alt">
              <button
                onClick={() =>
                  setViewAltTwo({
                    mentors: false,
                    employers: true,
                    companies: false,
                  })
                }
                className={
                  viewAltTwo.employers
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Employers
              </button>
              <button
                onClick={() =>
                  setViewAltTwo({
                    mentors: true,
                    employers: false,
                    companies: false,
                  })
                }
                className={
                  viewAltTwo.mentors
                    ? "section-title red background-black-lighten underline"
                    : "section-title red background-black-lighten"
                }
              >
                Mentors
              </button>
              <button
                onClick={() =>
                  setViewAltTwo({
                    mentors: false,
                    employers: false,
                    companies: true,
                  })
                }
                className={
                  viewAltTwo.companies
                    ? "section-title blue background-black-lighten underline"
                    : "section-title blue background-black-lighten"
                }
              >
                Companies
              </button>
            </div>
            <div className="setup-users-container-alt">
              {viewAltTwo.mentors && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 red"></i>
                    <p className="section-name">Mentors</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border red">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font">User Name</span>
                              </li>
                              <li className="user-online-item">Job Title</li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-red">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {viewAltTwo.employers && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Employers</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Employer Name
                                </span>
                              </li>
                              <li className="user-online-item">
                                Recruiter Name
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {viewAltTwo.companies && (
                <section className="friends-section">
                  <div className="user-section-name">
                    <i className="fas fa-users fa-lg mr-10 blue"></i>
                    <p className="section-name">Companies</p>
                  </div>
                  <div className="friend-results-setup">
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="user-section">
                      <div className="friends-user-container">
                        <div className="friend-user-avi-container">
                          <div className="avi-color-border blue">
                            <div className="friend-user-avi"></div>
                          </div>
                        </div>
                        <div className="friend-user-info">
                          <div className="online-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="blue name-font">
                                  Company Name
                                </span>
                              </li>
                              <li className="user-online-item">Location</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="friends-buttons-container">
                        <div className="friend-button-container">
                          <button className="friend-button background-blue">
                            <i className="fas fa-user-plus mx-5"></i>
                            Follow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

SetupProfileUsers.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SetupProfileUsers);
